<template>
  <section class="courses-list">
    <CourseCard v-for="course in courses" :key="course.id" :course="course" />
  </section>
</template>

<script>
import CourseCard from "../KidsReservation/CourseCard.vue";

export default {
  name: "CoursesList",
  components: {
    CourseCard,
  },
  props: {
    courses: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.courses-list {
  display: grid;
  max-width: calc($max-xl-screen - 324px);
  grid-template-columns: repeat(auto-fit, minmax(237px, 1fr));
  column-gap: 9px;
  row-gap: 16px;
}

@media all and (min-width: $min-md-screen) and (max-width: $max-lg-screen) {
  .courses-list {
    max-width: calc($max-lg-screen - 162px);
    column-gap: 10px;
    row-gap: 13px;
  }
}

@media all and (max-width: $min-md-screen) {
  .courses-list {
    width: 100%;
    grid-template-columns: repeat(2, minmax(auto, 50%));
    column-gap: 7px;
    row-gap: 16px;
  }
}
</style>
